import localization from "../../../../../assets/localization";
import Utility from "../../../logic/Utility";
import Analytics from "../../../../../utils/Analytics";
import { useSliderState } from "../SliderState";

export default function TemplateCTAs({ template }: any) {
  const sliderState = useSliderState();
  return (
    <div className="hotel-template-ctas">
      {template.ctas.map((cta: any, ctaIndex: any) => {
        if (cta.type === "url") {
          return (
            <a
              key={ctaIndex}
              href={Utility.getWithParams(
                cta.link,
                sliderState.assistantId,
                sliderState.threadId,
                cta.key === "quick_quote"
              )}
              target="_blank"
              style={{ textDecoration: "none" }}
              rel="noopener noreferrer"
              onClick={() =>
                Analytics.track("link_click", {
                  url: cta.link,
                  cta: cta.key,
                  source: "slider_cta",
                })
              }
            >
              <button className="message-template-cta-button">
                {localization.get(sliderState.language)[cta.key]}
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </a>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
